import React, { useState, useEffect } from 'react';
import {
  FaHome,
  FaUserAlt,
  FaCog,
  FaWrench,
  FaSignOutAlt,
  FaCar,
  FaTasks,
  FaFilePdf,
  FaFileInvoiceDollar,
  FaFileSignature,
  FaServer,
  FaClock,
  FaCalendarAlt,
  FaFileContract,
  FaFileAlt,
  FaExchangeAlt,
  FaFolderOpen,
  FaUpload,
} from 'react-icons/fa';
import { IoMdBusiness } from 'react-icons/io';
import { DiAptana } from 'react-icons/di';
import { useNavigate } from 'react-router-dom';
import { decodeToken, isExpired } from 'react-jwt';

function SideMenu() {
  // Sempre abre recolhido; o usuário expande pelo botão ☰ quando quiser.
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile]     = useState(window.innerWidth < 1024);
  const [userData, setUserData]     = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (!token || isExpired(token)) {
      window.location.href = '/login';
    } else {
      setUserData(decodeToken(token));
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) setIsExpanded(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu  = () => setIsExpanded(v => !v);
  const handleLogout = () => { localStorage.removeItem('jwtToken'); navigate('/login'); };
  const handleNav   = (path) => { navigate(path); if (isMobile) setIsExpanded(false); };

  // Itens são <a href> de verdade para o botão direito oferecer "Abrir em nova aba".
  // Ctrl/Shift/Cmd+clique e botão do meio ficam com o navegador; clique normal navega pelo router.
  const handleLinkClick = (e, path) => {
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    handleNav(path);
  };

  const menuLink = (path, icon, label) => (
    <li>
      <a href={path} style={styles.menuItem} onClick={(e) => handleLinkClick(e, path)}>
        {icon}<span style={styles.label}>{label}</span>
      </a>
    </li>
  );

  if (!userData) return null;

  const role        = (userData.tipoUsuario || '').toUpperCase();
  const isManager   = role === 'MANAGER';
  const isFuncionario = role === 'FUNCIONARIO';
  const isGerente   = role === 'GERENTE';
  const podeVerDespesas = isManager || isGerente;

  return (
    <>
      {isMobile && isExpanded && (
        <div onClick={() => setIsExpanded(false)} style={styles.overlay} />
      )}

      <div style={
        isMobile
          ? isExpanded ? styles.sidebarMobileOpen : styles.sidebarMobileClosed
          : isExpanded ? styles.sidebarOpen       : styles.sidebarClosed
      }>
        <button onClick={toggleMenu} style={styles.toggleButton}>
          <span style={styles.toggleIcon}>{isExpanded ? '✕' : '☰'}</span>
        </button>

        {isExpanded && (
          <nav>
            <div style={styles.menuHeader}>
              <span style={styles.menuHeaderText}>MENU</span>
            </div>
            <ul style={styles.menuList}>

              {menuLink('/home', <FaHome style={styles.icon} />, 'Página Inicial')}

              {menuLink('/ordemServico', <FaTasks style={styles.icon} />, 'Ordem de Serviço')}

              {menuLink('/Clientes', <FaCar style={styles.icon} />, 'Clientes e Veículos')}

              {/* ── Importar CRLV-e em lote — mesma posição do menu da página inicial */}
              {menuLink('/importar-crlv', <FaUpload style={styles.icon} />, 'Importar CRLV-e')}

              {/* ── NOVO: Processos — documentos dos processos guardados e pesquisáveis */}
              {menuLink('/processos', <FaFolderOpen style={styles.icon} />, 'Processos')}

              {/* ── NOVO: Procuração de Veículo — logo abaixo de Clientes e Veículos */}
              {menuLink('/procuracao', <FaFileSignature style={styles.icon} />, 'Procuração de Veículo')}

              {/* ── NOVO: Contratos — logo abaixo de Procuração de Veículo, visível para todos os perfis */}
              {menuLink('/contratos', <FaFileContract style={styles.icon} />, 'Contratos')}

              {/* ── NOVO: Documentos Complementares — logo abaixo de Contratos, visível para todos os perfis */}
              {menuLink('/documentos-complementares', <FaFileAlt style={styles.icon} />, 'Documentos Complementares')}

              {!isFuncionario && menuLink('/relatorios', <FaFilePdf style={styles.icon} />, 'Relatório de Caixa')}

              {menuLink('/cadastroServico', <FaWrench style={styles.icon} />, 'Serviços')}

              {/* ── NOVO: Despesas — visível para GERENTE e MANAGER */}
              {podeVerDespesas && menuLink('/despesas', <FaFileInvoiceDollar style={styles.icon} />, 'Despesas')}

              {/* ── NOVO: Agenda — logo abaixo de Despesas, visível para todos os perfis */}
              {menuLink('/agenda', <FaCalendarAlt style={styles.icon} />, 'Agenda')}

              {!isFuncionario && menuLink('/usuarios', <FaUserAlt style={styles.icon} />, 'Usuários')}

              {!isFuncionario && menuLink('/settings', <DiAptana style={styles.icon} />, 'Configurações')}

              {isManager && menuLink('/selecionar-empresa', <FaExchangeAlt style={styles.icon} />, 'Trocar Empresa')}

              {isManager && menuLink('/cadastroEmpresas', <IoMdBusiness style={styles.icon} />, 'Empresas')}

              {isManager && menuLink('/server-info', <FaServer style={styles.icon} />, 'Servidor')}

              {isManager && menuLink('/backups-crons', <FaClock style={styles.icon} />, 'Backups/CRONS')}

              <li style={{ ...styles.menuItem, ...styles.logoutItem }} onClick={handleLogout}>
                <FaSignOutAlt style={styles.icon} /><span style={styles.label}>Logout</span>
              </li>

            </ul>
          </nav>
        )}
      </div>
    </>
  );
}

// ── Estilos Sidebar ──────────────────────────────────────────────────────────
const BG_DARK = '#004d4d', BG_MID = '#008080', BG_BTN = '#003838';
const BORDER  = 'rgba(255,255,255,0.12)';

const styles = {
  sidebarOpen: {
    position:'fixed', top:0, left:0, width:'240px', height:'100%',
    background:`linear-gradient(160deg,${BG_DARK} 0%,${BG_MID} 100%)`,
    color:'#fff', transition:'width 0.3s ease', zIndex:1000,
    overflowY:'auto', overflowX:'hidden', boxShadow:'4px 0 20px rgba(0,0,0,0.2)',
  },
  sidebarClosed: {
    position:'fixed', top:0, left:0, width:'50px', height:'100%',
    background:`linear-gradient(160deg,${BG_DARK} 0%,${BG_MID} 100%)`,
    color:'#fff', transition:'width 0.3s ease', zIndex:1000,
    overflow:'hidden', boxShadow:'4px 0 20px rgba(0,0,0,0.2)',
  },
  sidebarMobileOpen: {
    position:'fixed', top:0, left:0, width:'280px', height:'100%',
    background:`linear-gradient(160deg,${BG_DARK} 0%,${BG_MID} 100%)`,
    color:'#fff', transition:'transform 0.3s ease', transform:'translateX(0)',
    zIndex:1001, overflowY:'auto', boxShadow:'4px 0 30px rgba(0,0,0,0.3)',
  },
  sidebarMobileClosed: {
    position:'fixed', top:0, left:0, width:'280px', height:'100%',
    background:`linear-gradient(160deg,${BG_DARK} 0%,${BG_MID} 100%)`,
    color:'#fff', transition:'transform 0.3s ease', transform:'translateX(-100%)',
    zIndex:1001, overflowY:'auto',
  },
  overlay: {
    position:'fixed', top:0, left:0, right:0, bottom:0,
    background:'rgba(0,0,0,0.45)', zIndex:1000,
  },
  toggleButton: {
    width:'100%', padding:'14px 12px', backgroundColor:BG_BTN,
    border:'none', borderBottom:`1px solid ${BORDER}`,
    color:'#fff', cursor:'pointer', display:'flex',
    alignItems:'center', justifyContent:'center',
  },
  toggleIcon:    { fontSize:'18px', lineHeight:1 },
  menuHeader:    { padding:'14px 16px 8px 16px', borderBottom:`1px solid ${BORDER}` },
  menuHeaderText:{ fontSize:'0.68rem', fontWeight:700, letterSpacing:'1.5px',
                   color:'rgba(255,255,255,0.55)', textTransform:'uppercase' },
  menuList:      { listStyleType:'none', padding:'8px 0', margin:0 },
  menuItem: {
    padding:'11px 16px', display:'flex', alignItems:'center', gap:'12px',
    color:'#fff', cursor:'pointer', fontSize:'0.88rem', fontWeight:500, textDecoration:'none',
    transition:'background 0.2s', borderLeft:'3px solid transparent',
  },
  logoutItem:    { marginTop:'8px', borderTop:`1px solid ${BORDER}`, color:'#ffaaaa' },
  icon:          { fontSize:'16px', flexShrink:0, opacity:0.9 },
  label:         { whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
};

export default SideMenu;
